import { cn } from '@/lib/utils';
import { getStatusLabel, getStatusColor } from '@/lib/utils';
import type { PropertyStatus } from '@/types';

interface StatusBadgeProps {
  status: PropertyStatus;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  return (
    <span className={cn(
      'badge',
      getStatusColor(status),
      className
    )}>
      {getStatusLabel(status)}
    </span>
  );
}
